import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';

import Hero from './patterns/Hero/Hero';
import Search from './patterns/Search/Search';
import Categories from './patterns/Categories/Categories';
import PopularQuestionsList from './patterns/PopularQuestionsList/PopularQuestionsList';

const FAQPage = () => (
  <>
    <Box
      marginVertical={{ xs: '2.5rem', lg: '3.5rem' }}
      width="100vw"
    >
      <Hero />
      <Search />
      <Categories />
      <PopularQuestionsList />
    </Box>
  </>
);

export default FAQPage;
